<template>
  <!--<div class="driver-file">-->
    <!--<div class="driver-file-list">-->
      <!--<div class="file-name file-item">文件名</div>-->
      <!--<div class="file-time file-item">修改时间</div>-->
      <!--<div class="file-type file-item">文件类型</div>-->
      <!--<div class="file-remark file-item">备注</div>-->
    <!--</div>-->
    <!--<div class="driver-file-list driver-list" v-for="(item,idx) in fileList">-->
      <!--<div class="file-name file-item content">-->
        <!--<icon-font :type="getFileIcon(item.fileType)" style="font-size: 24px;margin-right: 6px;height: 48px;line-height: 56px"></icon-font>-->
        <!--<span v-show="!item.bj" @click="chongmingm(item,idx)">{{item.fileName}}</span>-->
        <!--<a-input :ref="'input'+idx" v-show="item.bj" v-model="item.fileName" @blur="saveFileName(item)" style="width: 160px"/>-->
      <!--</div>-->
      <!--<div class="file-time file-item file-cz">-->
        <!--{{item.updateTime}}-->
      <!--</div>-->
      <!--<div class="file-type file-item file-cz">-->
        <!--{{item.fileType}}-->
      <!--</div>-->
      <!--<div class="file-remark file-item file-cz">-->
        <!--{{item.remark}}-->
      <!--</div>-->
      <!--<div class="file-operate">-->
        <!--<icon-font type="icon-xiazai" class="operator-icon" @click="downloadFile(item)"></icon-font>-->
        <!--<icon-font type="icon-shanchu1" class="operator-icon" @click="delFile(item)"></icon-font>-->
        <!--<icon-font type="icon-zhongmingming" class="operator-icon" @click="chongmingm(item,idx)"></icon-font>-->
      <!--</div>-->
    <!--</div>-->

  <!--</div>-->
  <div>
    <a-table
      ref="table"
      size="middle"
      :scroll="{x:true}"
      rowKey="id"
      :columns="columns"
      :dataSource="fileList"
      :pagination="false"
      :loading="loading"
      :customHeaderRow="customHeaderRow"
      :customRow="customRow"
      class="j-table-force-nowrap">
      <template :slot="column.scopedSlots?column.scopedSlots.customRender:''" slot-scope="text,record"  v-for="column in columns">
        <slot :name="column.scopedSlots?column.scopedSlots.customRender:''" v-bind="record" >
          <div v-if="column.dataIndex=='fileName'" :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text">
            <img object-fit="contain" v-if="record.coverImg || getFileIcon(record.fileType)=='icon-tupiantubiao'" class="file-icon-img" :src="getCoverImg(record)"/>
            <icon-font v-else :type="getFileIcon(record.fileType)" style="font-size: 24px;margin-right: 6px;vertical-align:bottom"></icon-font>

            <span>{{text || '-'}}</span>
          </div>
          <!--<div v-else-if="column.dataIndex=='fileName'  && record.bj" :style="{width: (column.width-20)+'px'}" :title="text">-->
            <!--<icon-font :type="getFileIcon(record.fileType)" style="font-size: 24px;margin-right: 6px;"></icon-font>-->
            <!--<a-input :ref="'input'+record.no"  v-model="record.fileName" @blur="saveFileName(record)" style="width: 160px;height: 36px !important;"/>-->
          <!--</div>-->
          <img :title="text" v-else-if="(column.dataIndex=='createByName' && record.createAvatar) || (column.dataIndex=='updateByName' && record.updateAvatar)" :src="getImgView((column.dataIndex=='createByName'?record.createAvatar:record.updateAvatar))" height="25px" alt="" style="width:25px;font-size: 12px;font-style: italic;border-radius:50%"/>
          <div :style="{width: (column.width-20)+'px'}" class="table-div-text" :title="text" v-else>{{text || '-'}}</div>
        </slot>
      </template>

      <span slot="action" slot-scope="text, record">
          <a-dropdown >
            <a class="ant-dropdown-link tb-span-click">操作 <a-icon type="down"  class="tb-span-click"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click.stop="downloadFile(record)">下载</a>
              </a-menu-item>
              <a-menu-item  v-has="'driver:del'">
                <a-popconfirm title="确定删除吗?" @confirm.stop="() => delFile(record)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
                  <a-menu-item>
                <a @click.stop="update(record)">修改</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
    </a-table>
    <driver-file-modal ref="fileModal" @ok="loadList"></driver-file-modal>
    <div ref="viewer" class="images" v-viewer="viewerOptions" style="display: none;">
      <img :src="previewImage" :key="previewImage">
    </div>
    <a-modal title="视频预览" :visible="videoVisible" :width="650" @cancel="hideVideo" @ok="hideVideo">
      <Video :width="600" :height="400" ref="veo" :zoom="'contain'"  :autoplay="true"  v-if="videoUrl"   style="margin-top: 10px;"   :videoUrl="videoUrl"
      ></Video>
    </a-modal>
  </div>
</template>

<script>

  import { mixin, mixinDevice } from '@/utils/mixin.js'
  import { httpAction, getAction,getFileAccessHttpUrl,deleteAction  } from '@/api/manage'
  import DriverFileModal from "../../../views/dm3/driver/modal/DriverFileModal";
  import Video from "../../../components/video/Video";
  export default {
    name: 'DriverFile',
    components: {DriverFileModal,Video},
    mixins: [mixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      }
    },data(){
      return {
        columns: [
          {
            title:'文件名',
            align:"center",
            fixed:'left',
            width:200,
            dataIndex: 'fileName',
            scopedSlots: { customRender: 'fileNameSlot' }
          },{
            title: '文件类型',
            dataIndex: 'fileType',
            align:"center",
            width:120,
            scopedSlots: { customRender: 'fileTypeSlot' }
          },
          {
            title:'上传人',
            align:"center",
            width:140,
            dataIndex: 'createByName',
            scopedSlots: { customRender: 'createByNameSlot' }
          },
          {
            title: '上传时间',
            dataIndex: 'createTime',
            align:"center",
            width:180,
            scopedSlots: { customRender: 'createTimeSlot' }
          },
          {
            title:'修改人',
            align:"center",
            width:140,
            dataIndex: 'updateByName',
            scopedSlots: { customRender: 'updateByNameSlot' },
          },
          {
            title:'修改时间',
            align:"center",
            width:180,
            dataIndex: 'updateTime',
            scopedSlots: { customRender: 'updateTimeSlot' },
          },
          {
            title: '备注',
            align:"center",
            width:200,
            dataIndex: 'remark',
            scopedSlots: { customRender: 'remarkSlot' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        fileTypeMap:{
          txt:'icon-txt',
          xlsx:'icon-excel-2',
          xls:'icon-excel-2',
          pdf:'icon-PDF',
          doc:'icon-word',
          docx:'icon-word',
          jepg:'icon-tupiantubiao',
          png:'icon-tupiantubiao',
          gif:'icon-tupiantubiao',
          jpg:'icon-tupiantubiao',
          webp:'icon-tupiantubiao',
          mp4:'icon-shipintubiao',
          avi:'icon-shipintubiao'
        },
        fileList:[

        ],
        tempName:'',
        loading:false,
        viewerOptions:{
          title: false, // 显示当前图片的标题(显示alt属性或从URL解析出的图片名称)[布尔值/数字/方法/数组：默认true]
          toolbar: true, // 显示工具栏、自定义工具栏[布尔值/数字/对象：默认true]
          movable: true, // 图片是否可移动[布尔值：默认true]
          zoomable: true, // 图片是否可缩放[布尔值：默认true]
          url: 'src' // 播放时图片地址 URL 来源。[字符串/方法：默认src](如果是字符串，则应该是每个图像元素的属性之一。 如果是方法，则应该返回一个有效的图像URL)
        },
        previewImage:"",
        previewVisible: false,
        videoUrl:"",
        videoVisible:false
      }
    },methods:{
      getImgView(text){
        if(text && text.indexOf(",")>0){
          text = text.substring(0,text.indexOf(","))
        }
        return getFileAccessHttpUrl(text)
      },
      getFileIcon(type){
        type = type.toLowerCase();
        return this.fileTypeMap[type] || 'icon-tongyongwenjiantubiaoda'
      },chongmingm(item){
        item.bj = true;

        this.$nextTick(()=>{
          this.$refs['input'+item.no][1].focus();
        })
        this.tempName = item.fileName;
      },saveFileName(item){
        if(!item.fileName){
          item.fileName = this.tempName;
        }
        item.bj = false;
        this.save(item);
      },save(item){
        httpAction("/dm/dmDriverFile/edit",item,"PUT");
      },delFile(item){
        deleteAction("/dm/dmDriverFile/delete",{id:item.id}).then(res=>{
          if(res.success){
            this.loadList();
          }
        });
      },downloadFile(item){
        if(!item.fileUrl){
          this.$message.warning("未知的文件")
          return;
        }
        let url = getFileAccessHttpUrl(item.fileUrl);
        window.open(url);
      },loadList(){
        this.fileList = []
        getAction("/dm/dmDriverFile/list",{driverId:this.driverId,pageSize:1000}).then(res=>{
          if(res.success){
            if(res.result.records){
              for(let a in res.result.records){
                res.result.records[a].bj = false;
                res.result.records[a].no = a;
              }
            }
            this.fileList = res.result.records;
          }
        })
      },customHeaderRow(conlumn){
      conlumn.forEach((e,index)=>{
        conlumn[index].className = 'header-class'
      })
    },customRow(record){
        let that = this;
        return {
          on:{
            click:(e)=>{
              if(e.target._prevClass&&e.target._prevClass.indexOf('tb-span-click')!=-1){
                return;
              }
              that.viewFile(record)
            }
          },
          class:"row-class"
        }
     },update(record){
        this.$refs.fileModal.edit(record);
      },viewFile(record){
        if('jpeg|jpg|png|tiff|bmp|gif|webp|svg|eps'.indexOf(record.fileType)!=-1){
          this.handlePreview(record.fileUrl);
        }else if("mp4|avi".indexOf(record.fileType)!=-1){
          this.videoUrl = record.fileUrl;
          this.videoVisible = true;
        }else if("docx|doc|xlsx|xls|pptx|ppt|pdf".indexOf(record.fileType)!=-1){
          window.open("https://view.officeapps.live.com/op/view.aspx?src="+ record.fileUrl);
        }
      },hideVideo(){
        this.videoUrl = "";
        this.videoVisible = false;
        this.$refs.veo.stop();
      },
      // 预览
      handlePreview (fileUrl) {
        this.previewImage = getFileAccessHttpUrl(fileUrl);
        this.previewVisible = true
        this.$refs.viewer.$viewer.show();
      },getCoverImg(record){
        if(record.coverImg){
          return getFileAccessHttpUrl(record.coverImg);
        }
        return getFileAccessHttpUrl(record.fileUrl)
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  @import '~@assets/less/dm/tableList.less';
  @import '~@assets/less/dm/newTable.less';

  .file-icon-img{
    width: 17px;
    height: 21px;
    margin-right: 6px;
    border-radius: 3px;
  }
  /*.driver-file{*/
    /*background: #fff;*/
    /*width: 800px;*/
    /*border-radius: 12px;*/
    /*min-height: 400px;*/
    /*padding: 12px 24px;*/
    /*font-size: 16px;*/
  /*}*/
  /*.driver-file-list{*/
    /*display: flex;*/
    /*height: 48px;*/
    /*line-height: 48px;*/
  /*}*/
  /*.driver-list{*/
    /*cursor: pointer;*/
  /*}*/

  /*.driver-file-list .content{*/
    /*color: rgb(10, 22, 41);*/
    /*display: flex;*/
  /*}*/
  /*.file-item{*/
    /*margin-right: 24px;*/
  /*}*/
  /*.file-item span{*/
    /*overflow: hidden;*/
    /*text-overflow:ellipsis;*/
    /*white-space: nowrap;*/
  /*}*/
  /*.file-name{*/
    /*width: 201px;*/

  /*}*/
  /*.file-time{*/
    /*width: 163px;*/

  /*}*/
  /*.file-type{*/
    /*width: 88px;*/
  /*}*/
  /*.file-remark{*/
    /*width: 202px;*/
  /*}*/

  /*.file-operate{*/
    /*display: none;*/
  /*}*/

  /*.driver-list:hover .file-operate{*/
    /*display: block !important;*/
  /*}*/

  /*.driver-list:hover .file-cz{*/
    /*display: none !important;*/
  /*}*/

  /*.operator-icon{*/
    /*font-size: 16px;*/
    /*margin-right: 12px;*/
    /*cursor: pointer;*/
    /*color: #000;*/

  /*}*/
</style>